import { DialogOptions } from 'components/core/Dialog/common/Dialog';
import { FormattedMessage } from 'intl';
import { DialogTranslationKeys, CommonTranslationKeys } from 'intl/keys';
import { translationKeyToString } from 'intl/types/translationKey';

export function documentationDownloadDirectoryDialog(): DialogOptions {
  return {
    catchOnCancel: false,
    title: (
      <FormattedMessage id={DialogTranslationKeys.confirmationDownloadDirectoryTitle} />
    ),
    description: (
      <span>
        <FormattedMessage id={DialogTranslationKeys.confirmationDownloadDirectoryDescription} />
      </span>
    ),
    customControllerLabels: [
      translationKeyToString(CommonTranslationKeys.cancel),
      translationKeyToString(CommonTranslationKeys.yes),
    ],
  };
}
